module.exports = __webpack_public_path__ + "img/ic-info.b368b06f.svg";